<template>
    <modal title-modal="Configuração de Desconto" modal-large id-modal="config-discount-modal">
        <template #title>Configuração de Desconto</template>
        <div class="modal-body">

            <div class="row gutters">
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                    <div class="form-group">
                        <label for="min_value">Valor mínimo de desconto: </label>
                        <div class="input-group">
                            <input class="form-control" type="text" id="min_value" name="min_value"
                                   v-model.lazy="min.value" v-money3="configVMoney">
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 mt-4">
                    <div class="custom-control custom-switch">
                        <input type="checkbox"
                               class="custom-control-input"
                               id="min_active"
                               v-model="min.active">
                        <label class="custom-control-label pointer" for="min_active">{{ t('ALLOTMENT.ACTIVE') }}</label>
                    </div>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                    <div class="form-group">
                        <label for="max_value">Valor máximo de desconto: </label>
                        <div class="input-group">
                            <input class="form-control" type="text" id="max_value" name="max_value"
                                   v-model.lazy="max.value" v-money3="configVMoney">
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 mt-4">
                    <div class="custom-control custom-switch">
                        <input type="checkbox"
                               class="custom-control-input"
                               id="max_active"
                               v-model="max.active">
                        <label class="custom-control-label pointer" for="max_active">{{ t('ALLOTMENT.ACTIVE') }}</label>
                    </div>
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="custom-control custom-switch">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="discount_config_fixed"
                           v-model="fixed"
                           @change="changeVMoneyConfig($event.target.checked)">
                    <label class="custom-control-label pointer" for="discount_config_fixed">Valor em Reais (R$)</label>
                </div>
            </div>
        </div>

        <div class="modal-footer" style="justify-content: space-between">
            <div class="btn btn-secondary" data-dismiss="modal" id="closeD" @click="closeModal">{{
                    t('ACTIONS.CLOSE')
                }}
            </div>
            <div class="btn btn-primary ml-2" @click="save">{{ t('ACTIONS.SAVE') }}</div>
        </div>
    </modal>
</template>

<script>

import {useI18n} from 'vue-i18n';
import {Money3Directive} from 'v-money3';
import modal from '@/components/modal.vue';
import Translate from '@/Helpers/Translate';
import {useToast} from 'vue-toastification';

export default {
    name: 'configDiscountComponent',

    directives: {money3: Money3Directive},

    components: {
        modal,
    },

    emits: ['updateDiscount'],

    setup() {
        const {t} = useI18n();
        const toast = useToast();

        return {t, toast};
    },

    data() {
        return {
            fixed: true,
            min: {
                value: 0,
                active: false,
            },
            max: {
                value: 0,
                active: false,
            },
            configVMoney: {},
        };
    },

    methods: {
        setDiscountConfig(config) {
            const discountConfig = {
                fixed: config.fixed,
                min: {
                    value: config.min.value * 100,
                    active: config.min.active,
                },
                max: {
                    value: config.max.value * 100,
                    active: config.max.active,
                },
            };

            this.min = discountConfig.min;
            this.max = discountConfig.max;
            this.fixed = discountConfig.fixed;
            this.setVMoneyConfig(discountConfig.fixed);
        },

        changeVMoneyConfig(isFixed) {
            this.min.value = 0;
            this.max.value = 0;

            this.setVMoneyConfig(isFixed);
        },

        setVMoneyConfig(isFixed = this.fixed) {
            if (isFixed) {
                this.configVMoney = {
                    ...this.configVMoney,
                    suffix: '',
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    disabled: false,
                    max: 100000000000,
                    minimumNumberOfCharacters: 1,
                };
            } else {
                this.configVMoney = {
                    ...this.configVMoney,
                    max: 100,
                    prefix: '',
                    decimal: '.',
                    thousands: '',
                    suffix: '%',
                    disabled: false,
                    minimumNumberOfCharacters: 0,
                };
            }
        },

        closeModal() {
            document.getElementById('closeD')?.click();
        },

        save() {
            const data = {
                fixed: this.fixed,
                min: {
                    value: Translate.parseMoneyOrPercentToFloat(this.min.value),
                    active: this.min.active,
                },
                max: {
                    value: Translate.parseMoneyOrPercentToFloat(this.max.value),
                    active: this.max.active,
                },
            };

            if (this.$route.params.action !== 'adicionar') {
                this.$swal.fire({
                    title: 'Tem Certeza?',
                    text: 'A alteração será aplicada imediatamente.',
                    icon: 'question',
                    showCancelButton: true,
                    showCloseButton: false,
                    confirmButtonText: 'Atualizar',
                    cancelButtonText: 'Cancelar',
                }).then(result => {
                    if (result.isConfirmed) this.$emit('updateDiscount', data);
                });
            } else this.$emit('updateDiscount', data);
        },
    },
};

</script>
